import CollectionCard from '../../components/ListCard/CollectionCard';

const DataCollectionPage = () => {
  return (
    <>
      <div
        id="data_collection"
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '-webkit-fill-available',
          backgroundColor: '#F8FAF9',
        }}
      >
        <div
          style={{
            backgroundSize: 'cover',
          }}
        >
          <div
            style={{
              margin: '30px 10%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <h1
              style={{
                color: '#2C3E37',
                fontWeight: 'bolder',
                fontSize: '36px',
              }}
            >
              Data Collections
            </h1>
            <p
              style={{
                color: '#2C3E37',
                fontWeight: 'bold',
                fontSize: '18px',
              }}
            >
              Interactive dashboards and web pages curated by data providers.
            </p>
          </div>
        </div>
        <div
          style={{
            backgroundColor: '#CEDBD6',
            backgroundSize: 'cover',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '35px',
          }}
        >
          <CollectionCard
            title={'California Interagency Treatment Tracking System'}
            handleView={() => {
              window.open(
                'https://www.wildfirecommons.org/ckandata?org=California%20Interagency%20Treatment%20Tracking%20System',
                '_blank',
                'noopener,noreferrer'
              );
            }}
            type="ITS"
            info="The California Wildfire and Landscape Interagency Treatment Dashboard, for the first time ever in California, provides a single source for displaying recently completed forest and wildland projects from over a dozen different federal and state agencies."
          />
          <CollectionCard
            title={'California Landscape Metrics'}
            handleView={() => {
              window.open(
                'https://www.wildfirecommons.org/ckandata?org=California%20Landscape%20Metrics',
                '_blank',
                'noopener,noreferrer'
              );
            }}
            type="CLM"
            info="The California Landscape metrics are a set of data created to accelerate the work by regional partners and collaboratives to reduce wildfire hazard and improve the conditions of forested and shrub landscapes."
          />
          <CollectionCard
            title={'Southern California Ignition Reduction Program'}
            // handleView={() => {
            //   window.open(
            //     'https://www.wildfirecommons.org/ckandata?org=California%20Landscape%20Metrics',
            //     '_blank',
            //     'noopener,noreferrer'
            //   );
            // }}
            type="SCIRP"
            info="The Southern California Ignition Reduction Program (SCIRP) is a public-private partnership of governmental agencies and their partners working together to reduce human caused ignitions, primarily along roadsides. SCIRP crosses jurisdictional boundaries to systematically plan, prioritize, fund, and implement projects that use vegetation treatments and physical barriers along roadways to prevent wildfires."
          />
        </div>
      </div>
    </>
  );
};
export default DataCollectionPage;
